<div class="transfer-borrower-modal">
  <div class="tbm-header">
    <h2 class="tbm-title">
      <i class="fas fa-right-left tbm-title-icon" aria-hidden="true"></i>
      Transfer Borrower Data
    </h2>
  </div>

  <div class="tbm-body">
    <p class="tbm-caption" [hidden]="!isSearchPhase((stage$ | async))">
      Select a borrower to transfer all documents and settings to. Test entities will be
      deleted after their data is transferred. If the destination entity has any documents
      uploaded, you will have to delete them before you can transfer data over.
    </p>

    <app-transfer-target-search
      [hidden]="!isSearchPhase((stage$ | async))"
      [sourceUuid]="source.uuid || ''"
      [error]="bandError$ | async"
      (whenSelected)="onTargetSelected($event)">
    </app-transfer-target-search>

    <app-transfer-confirmation
      [hidden]="!isConfirmPhase((stage$ | async))">
    </app-transfer-confirmation>
  </div>

  <div class="tbm-footer" [ngSwitch]="(stage$ | async)">
    <ng-container *ngSwitchCase="TransferStage.SEARCHING">
      <button type="button" class="btn btn-link tbm-cancel-btn" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn btn-primary tbm-next-btn" (click)="onNext()">Next</button>
    </ng-container>
    <ng-container *ngSwitchCase="TransferStage.VALIDATING">
      <button type="button" class="btn btn-link tbm-cancel-btn" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn btn-primary tbm-next-btn" disabled>Validating…</button>
    </ng-container>
    <ng-container *ngSwitchCase="TransferStage.INELIGIBLE">
      <button type="button" class="btn btn-link tbm-cancel-btn" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn btn-primary tbm-next-btn" (click)="onNext()">Next</button>
    </ng-container>
    <ng-container *ngSwitchCase="TransferStage.VALIDATED">
      <button type="button" class="btn btn-link tbm-back-btn" (click)="onBack()">
        <i class="fa fa-arrow-left tbm-back-icon"></i><span class="tbm-back-label">Back</span>
      </button>
      <button type="button" class="btn btn-link tbm-cancel-btn" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn btn-primary tbm-submit-btn"
              (click)="onSubmit()">Submit</button>
    </ng-container>
    <ng-container *ngSwitchCase="TransferStage.EXECUTING">
      <button type="button" class="btn btn-link tbm-back-btn" disabled>
        <i class="fa fa-arrow-left tbm-back-icon"></i><span class="tbm-back-label">Back</span>
      </button>
      <button type="button" class="btn btn-link tbm-cancel-btn" disabled>Cancel</button>
      <button type="button" class="btn btn-primary tbm-submit-btn" disabled>Submitting…</button>
    </ng-container>
    <ng-container *ngSwitchCase="TransferStage.EXECUTION_FAILED">
      <button type="button" class="btn btn-link tbm-cancel-btn" (click)="onCancel()">Close</button>
      <button type="button" class="btn btn-primary tbm-try-again-btn" (click)="onTryAgain()">Try again</button>
    </ng-container>
  </div>
</div>
